import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import Footer from "./components/Footer";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Landing from './pages/Landing';
import LandingNavBar from './components/landing/landingnavbar/LandingNavBar';
import MainC from './components/main';
import HeaderNavbar from "./components/header/HeaderNavbar";
import Footer from "./components/footer/Footer";
import ScrollToTop from "./components/header/ScrollToTop";
import FloatingGetStarted from "./components/header/FloatingGetStarted";
// import WhatsAppButton from "./components/header/WhatsAppButton";

function App() {
  return (
    <div>

    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(


  <Router basename="/business">
  {/* <Router> */}
    {/* <ScrollToTop /> */}
    <HeaderNavbar />

    <Routes>
      {/* <Route path="/" element={<Landing />} /> */}
      <Route path="/" element={<LandingNavBar landing="landing" />} />
      <Route path="/aboutus" element={<LandingNavBar content="About us component" navBar="aboutus" />} />
      <Route path="/faq" element={<LandingNavBar content="FAQ component" navBar="faq" />} />
      {/* <Route path="/pricing" element={<LandingNavBar content="Pricing component" navBar="pricing" /> } /> */}
      <Route path="/pricing" element={<LandingNavBar navBar="pricing" page="pricing" />} />
      <Route path="/pricing/compare" element={<LandingNavBar navBar="pricing" page="compare" />} />
      <Route path="/demo" element={<LandingNavBar content="Demo component" navBar="demo" />} />
      <Route path="/blog" element={<LandingNavBar content="Blog component" navBar="blog" />} />
      <Route path="/contact" element={<LandingNavBar content="Contact component" navBar="contact" />} />
      {/* Removed login route - handled by main app via /business/login redirect */}
      <Route path="/printingmaterial" element={<LandingNavBar content="Printing Material component" navBar="printingmaterial" />} />
      {/* <Route path="/contact" element={<Contact />} /> */}
    </Routes>
    {/* <WhatsAppButton /> */}
    <div className="fixed bottom-6 left-6 z-50">
      <button
        onClick={() => window.location.href = "/business/contact"}
        className="inline-flex items-center justify-center gap-2 whitespace-nowrap border border-[#6E3FC6] bg-[#e9d9ff] hover:bg-[#d8bfff] text-black text-sm sm:text-base font-medium px-[18px] sm:px-[25px] rounded-full transition-all duration-300 cursor-pointer shadow-lg"
        style={{ height: "48px", minHeight: "48px" }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
        book a demo
      </button>
    </div>
    <FloatingGetStarted />
    <Footer></Footer>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

